// extracted by mini-css-extract-plugin
module.exports = {"carousel":"styles-module--carousel--3G6UQ","logo":"styles-module--logo--3hUaz","container":"styles-module--container--1oWP2","ctrl":"styles-module--ctrl--1DxYN"};